import React from 'react';
import styles from './spinner.module.scss';

const Spinner = () => (
  <div className={styles.lds_ring}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default Spinner;
